<script>
export default {
  inheritAttrs: false,
  props: {
    value: {
      type: Boolean,
      default: undefined,
    },
    label: {
      type: String,
      default: '',
    },
  },
  emits: ['update', 'change'],
  computed: {
    addOnChange() {
      return {
        ...this.$attrs,
        onChange: (event) => {
          this.$emit('update', event.target.checked)
          this.$emit('change', event)
        },
      }
    },
  },
}
</script>

<template>
  <label :class="$style.container">
    <input
      ref="input"
      v-bind="addOnChange"
      :value="value"
      :class="$style.input"
      type="checkbox"
    />
    <span :class="$style.label">{{ label }}</span>
  </label>
</template>

<style lang="scss" module>
@use '@design' as *;

.container {
  display: block;
  margin-bottom: $size-grid-padding;
  cursor: pointer;

  input {
    margin-right: $size-grid-padding * 0.4;
    cursor: pointer;
  }
}

.label {
  @extend %typography-label;

  color: $color-input-label;
  cursor: pointer;
}
</style>
